import { Localizations } from "@/helpers/useLocalization";

export type europeanLanderSlugs =
  | "hero.title"
  | "hero.subtitle"
  | "hero.get-samples-btn"
  | "certifications.headline"
  | "certifications.body"
  | "process-certifications"
  | "battery-safety"
  | "mdr.eyebrow"
  | "mdr.headline"
  | "mdr.body"
  | "mdr.name"
  | "mdr.email"
  | "mdr.phone"
  | "mdr.button"
  | "mdr.captcha-error"
  | "mdr.disclaimer"
  | "explore-out-lineup-stocked-in-the-eu"
  | "category.cartridges.title"
  | "category.cartridges.body"
  | "category.all-in-ones.title"
  | "category.all-in-ones.body"
  | "category.batteries.title"
  | "category.batteries.body"
  | "active-axil-mini-air-description"
  | "active-axil-mini-pro-description"
  | "active-axil-description"
  | "active-leaf-description"
  | "active-ceramic-description"
  | "ezclick-ceramic-pro-description"
  | "ezclick-glass-description"
  | "active-root-xl-description"
  | "active-sprout-description"
  | "singular.headline"
  | "singular.body"
  | "available-mouthpieces"
  | "view-link"
  | "products-available-from-our-global-facilities"
  | "customizations.headline"
  | "customizations.body"
  | "customizations.button"
  | "trusted-by-top-brands";

export const europeanLanderLocalizations = {
  [Localizations.English]: {
    "hero.title":
      "Trusted by Europe’s leading medical and recreational cannabis vape brands",
    "hero.subtitle": "Stocked in Prague and ready to ship",
    "hero.get-samples-btn": "Contact us for orders",

    "certifications.headline": "Certified for European safety compliance",
    "certifications.body":
      "All products are produced in internationally certified manufacturing plants that follow rigorous quality controls. Batteries and all-in-one devices are CE certified and WEEE marked.",
    "process-certifications": "Process certifications",
    "battery-safety": "Battery safety",

    "mdr.eyebrow": "ACTIVE MDR Program",
    "mdr.headline": "Launch your own MDR-certified device in Europe",
    "mdr.body":
      "Share your details and our European MDR team will be in touch.",
    "mdr.name": "Name",
    "mdr.email": "Work email",
    "mdr.phone": "Phone number",
    "mdr.button": "Start your MDR conversation",
    "mdr.captcha-error": "Please confirm you are not a robot.",
    "mdr.disclaimer":
      "By submitting this form, you agree that ACTIVE may use your information to respond to your enquiry. See our <a href=\"/policy/privacy-policy\">Privacy Policy</a> for more information.",

    "explore-out-lineup-stocked-in-the-eu": "Products stocked in the EU",

    "category.cartridges.title": "Cartridges",
    "category.cartridges.body":
      "You’ll find <a href=\"/no-burn-vapor-technology\">ACTIVE's No-Burn Technology®</a> in every ACTIVE cartridge. Powered by our proprietary ceramic core, we’ve perfected how oil is absorbed, heated, and vaporized.",
    "category.all-in-ones.title": "All-In-Ones",
    "category.all-in-ones.body":
      "Consumers often mix and match batteries and cartridges. But to ensure your customers an optimal experience, consider ACTIVE all-in-ones. A cartridge and battery combination perfectly synced to deliver the nuances of your flavors in just the way you intended.",
    "category.batteries.title": "Batteries",
    "category.batteries.body":
      "Overheating degrades your oil. So ACTIVE batteries are engineered to regulate temperature with ACTIVE Pulse technology. Your cannabinoid-rich formulations and true-to-strain flavors are preserved without sacrificing the big hit.",

    "active-axil-mini-air-description":
      "Delightfully different. Small on the outside, big on the inside. Engineered for your distillates and novel cannabinoids, and compatible with liquid live resin.",
    "active-axil-mini-pro-description":
      "Rare for its size, the Mini Pro features high-end engineering with zirconia ceramic for exceptional flavor.",
    "active-axil-description":
      "Priced to compete in the mass market without sacrificing reliability and consistency. Engineered for your distillates and novel cannabinoids.",
    "active-leaf-description":
      "Delightfully different. Small on the outside, big on the inside. Engineered for your distillates and novel cannabinoids, and compatible with liquid live resin.",
    "active-ceramic-description":
      "Engineered for your premium extracts. All the looks and outstanding flavor delivery with a glass body and ceramic zirconia centerpost.",
    "ezclick-ceramic-pro-description":
      "Engineered for premium extracts, the Ceramic Pro features a glass body and zirconia center post for exceptional flavor delivery.",
    "ezclick-glass-description":
      "A balance of taste, affordability, and reliability for your distillates and novel cannabinoids in a glass body.",
    "active-root-xl-description":
      "A wider body, designed to perfectly fit and enhance the experience of ACTIVE XL cartridges.",
    "active-sprout-description":
      "Engineered for versatility with adjustable voltage, wattage, and ACTIVE Pulse to suit every extract.",
    "available-mouthpieces": "Available mouthpieces:",
    "singular.headline": "Singular® Universal Vape Platform",
    "singular.body":
      "Singular is a first-of-its-kind modular platform. Engineered for any extract with reusable batteries. And defined by signature form factors that are unmistakably yours.",
    "view-link": "View",

    "products-available-from-our-global-facilities":
      "All other products available from our global facilities",

    "trusted-by-top-brands": "TRUSTED BY TOP BRANDS",

    "customizations.headline": "Stand apart with customization",
    "customizations.body":
      "Our specialist customization team will collaborate to deliver a distinctive look for your brand.",
    "customizations.button": "Start your brand customization",
  },

  // 🇨🇿 CZECH
  [Localizations.Czech]: {
    "hero.title":
      "Důvěra předních evropských značek zdravotnických a rekreačních konopných vaporizérů",
    "hero.subtitle": "Skladem v Praze a připraveno k odeslání",
    "hero.get-samples-btn": "Kontaktujte nás pro objednávky",

    "certifications.headline":
      "Certifikováno podle evropských bezpečnostních norem",
    "certifications.body":
      "Všechny produkty jsou vyráběny v mezinárodně certifikovaných výrobních závodech s přísnou kontrolou kvality. Baterie a all-in-one zařízení mají certifikaci CE a označení WEEE.",
    "process-certifications": "Certifikace procesů",
    "battery-safety": "Bezpečnost baterií",

    "mdr.eyebrow": "Program ACTIVE MDR",
    "mdr.headline": "Uveďte v Evropě na trh vlastní zařízení s certifikací MDR",
    "mdr.body": "Sdělte nám své údaje a náš evropský tým pro MDR se vám ozve.",
    "mdr.name": "Jméno",
    "mdr.email": "Pracovní e-mail",
    "mdr.phone": "Telefonní číslo",
    "mdr.button": "Zahájit konverzaci o MDR",
    "mdr.captcha-error": "Potvrďte prosím, že nejste robot.",
    "mdr.disclaimer":
      "Odesláním tohoto formuláře souhlasíte s tím, že společnost ACTIVE může vaše údaje použít k zodpovězení vašeho dotazu. Více informací najdete v našich <a href=\"/policy/privacy-policy\">Zásadách ochrany osobních údajů</a>.",

    "explore-out-lineup-stocked-in-the-eu": "Produkty skladem v EU",

    "category.cartridges.title": "Cartridge",
    "category.cartridges.body":
      "V každé cartridge ACTIVE najdete <a href=\"/no-burn-vapor-technology\">technologii No-Burn Technology®</a> od ACTIVE. Díky našemu vlastnímu keramickému jádru jsme zdokonalili, jak se olej vstřebává, zahřívá a odpařuje.",
    "category.all-in-ones.title": "All-in-one zařízení",
    "category.all-in-ones.body":
      "Spotřebitelé často kombinují baterie a cartridge od různých výrobců. Chcete-li svým zákazníkům zajistit optimální zážitek, zvažte all-in-one zařízení ACTIVE. Kombinace cartridge a baterie dokonale sladěná tak, aby přenesla nuance vašich chutí přesně podle vašich představ.",
    "category.batteries.title": "Baterie",
    "category.batteries.body":
      "Přehřívání znehodnocuje váš olej. Baterie ACTIVE jsou proto navrženy tak, aby regulovaly teplotu pomocí technologie ACTIVE Pulse. Vaše receptury bohaté na kanabinoidy a autentické odrůdové chutě zůstanou zachovány, aniž byste se museli vzdát velkého potahu.",

    "active-axil-mini-air-description":
      "Příjemně odlišný. Malý navenek, velký uvnitř. Navržen pro destiláty a nové kanabinoidy, kompatibilní s tekutým live resin.",
    "active-axil-mini-pro-description":
      "Výjimečný ve své velikosti: Mini Pro nabízí špičkové technické řešení se zirkonovou keramikou pro výjimečnou chuť.",
    "active-axil-description":
      "Cenově dostupný pro masový trh bez kompromisů v oblasti spolehlivosti a konzistence. Navržen pro destiláty a nové kanabinoidy.",
    "active-leaf-description":
      "Příjemně odlišný. Malý navenek, velký uvnitř. Navržen pro destiláty a nové kanabinoidy, kompatibilní s tekutým live resin.",
    "active-ceramic-description":
      "Navržen pro prémiové extrakty. Elegantní vzhled a vynikající podání chuti díky skleněnému tělu a zirkonovému keramickému středovému sloupku.",
    "ezclick-ceramic-pro-description":
      "Navržen pro prémiové extrakty. Ceramic Pro má skleněné tělo a zirkonový středový sloupek pro výjimečné chuťové podání.",
    "ezclick-glass-description":
      "Vyvážený poměr chuti, dostupné ceny a spolehlivosti pro vaše destiláty a nové kanabinoidy ve skleněném těle.",
    "active-root-xl-description":
      "Širší tělo navržené tak, aby dokonale padlo k cartridgím ACTIVE XL a umocnilo zážitek z nich.",
    "active-sprout-description":
      "Navržena pro všestrannost – s nastavitelným napětím, výkonem a technologií ACTIVE Pulse pro každý extrakt.",
    "available-mouthpieces": "Dostupné náustky:",
    "singular.headline": "Univerzální vape platforma Singular®",
    "singular.body":
      "Singular je jedinečná modulární platforma. Navržena pro jakýkoli extrakt s opakovaně použitelnými bateriemi a definována charakteristickými tvary, které jsou nezaměnitelné.",
    "view-link": "Zobrazit",

    "products-available-from-our-global-facilities":
      "Všechny ostatní produkty jsou dostupné z našich globálních výrobních kapacit",

    "trusted-by-top-brands": "DŮVĚRA ŠPIČKOVÝCH ZNAČEK",

    "customizations.headline": "Odlište se díky přizpůsobení",
    "customizations.body":
      "Náš specializovaný tým pro přizpůsobení s vámi bude spolupracovat na vytvoření jedinečného vzhledu vaší značky.",
    "customizations.button": "Zahájit přizpůsobení značky",
  },

  // 🇳🇱 DUTCH
  [Localizations.Dutch]: {
    "hero.title":
      "Vertrouwd door toonaangevende medische en recreatieve cannabis vape-merken in Europa",
    "hero.subtitle": "Op voorraad in Praag en klaar voor verzending",
    "hero.get-samples-btn": "Neem contact met ons op voor bestellingen",

    "certifications.headline": "Gecertificeerd voor Europese veiligheidsnormen",
    "certifications.body":
      "Alle producten worden geproduceerd in internationaal gecertificeerde productiefaciliteiten met strenge kwaliteitscontroles. Batterijen en all-in-one apparaten zijn CE-gecertificeerd en WEEE-gemarkeerd.",
    "process-certifications": "Procescertificeringen",
    "battery-safety": "Batterijveiligheid",

    "mdr.eyebrow": "ACTIVE MDR-programma",
    "mdr.headline": "Lanceer uw eigen MDR-gecertificeerde apparaat in Europa",
    "mdr.body":
      "Deel uw gegevens en ons Europese MDR-team neemt contact met u op.",
    "mdr.name": "Naam",
    "mdr.email": "Zakelijk e-mailadres",
    "mdr.phone": "Telefoonnummer",
    "mdr.button": "Start uw MDR-gesprek",
    "mdr.captcha-error": "Bevestig dat u geen robot bent.",
    "mdr.disclaimer":
      "Door dit formulier te verzenden, gaat u ermee akkoord dat ACTIVE uw gegevens mag gebruiken om op uw vraag te reageren. Zie ons <a href=\"/policy/privacy-policy\">Privacybeleid</a> voor meer informatie.",

    "explore-out-lineup-stocked-in-the-eu": "Producten op voorraad in de EU",

    "category.cartridges.title": "Cartridges",
    "category.cartridges.body":
      "In elke ACTIVE-cartridge vindt u <a href=\"/no-burn-vapor-technology\">ACTIVE's No-Burn Technology®</a>. Dankzij onze eigen keramische kern hebben we geperfectioneerd hoe olie wordt opgenomen, verhit en verdampt.",
    "category.all-in-ones.title": "All-in-one apparaten",
    "category.all-in-ones.body":
      "Consumenten combineren batterijen en cartridges vaak naar eigen inzicht. Maar wilt u uw klanten een optimale ervaring bieden, overweeg dan de all-in-one apparaten van ACTIVE. Een cartridge en batterij die perfect op elkaar zijn afgestemd om de nuances van uw smaken precies zo over te brengen als u bedoeld heeft.",
    "category.batteries.title": "Batterijen",
    "category.batteries.body":
      "Oververhitting tast uw olie aan. Daarom zijn ACTIVE-batterijen ontworpen om de temperatuur te reguleren met ACTIVE Pulse-technologie. Uw cannabinoïderijke formuleringen en authentieke strain-smaken blijven behouden, zonder in te leveren op een stevige hit.",

    "active-axil-mini-air-description":
      "Aangenaam anders. Klein van buiten, groot van binnen. Ontworpen voor distillaten en nieuwe cannabinoïden, en compatibel met vloeibare live resin.",
    "active-axil-mini-pro-description":
      "Uniek in zijn formaat: de Mini Pro combineert hoogwaardige engineering met zirkonia-keramiek voor uitzonderlijke smaak.",
    "active-axil-description":
      "Geprijsd voor de massamarkt zonder in te leveren op betrouwbaarheid en consistentie. Ontworpen voor distillaten en nieuwe cannabinoïden.",
    "active-leaf-description":
      "Aangenaam anders. Klein van buiten, groot van binnen. Ontworpen voor distillaten en nieuwe cannabinoïden, en compatibel met vloeibare live resin.",
    "active-ceramic-description":
      "Ontworpen voor premium extracten. Stijlvol design en uitstekende smaakafgifte met een glazen behuizing en een zirkonia-keramische centerpost.",
    "ezclick-ceramic-pro-description":
      "Ontworpen voor premium extracten. De Ceramic Pro heeft een glazen behuizing en een zirkonia centerpost voor uitzonderlijke smaak.",
    "ezclick-glass-description":
      "Een balans tussen smaak, betaalbaarheid en betrouwbaarheid voor uw distillaten en nieuwe cannabinoïden, in een glazen behuizing.",
    "active-root-xl-description":
      "Een bredere behuizing, ontworpen om perfect te passen bij ACTIVE XL-cartridges en de ervaring te versterken.",
    "active-sprout-description":
      "Ontworpen voor veelzijdigheid met instelbare spanning, wattage en ACTIVE Pulse, geschikt voor elk extract.",
    "available-mouthpieces": "Beschikbare mondstukken:",
    "singular.headline": "Singular® Universeel Vape Platform",
    "singular.body":
      "Singular is een uniek modulair platform. Ontworpen voor elk extract met herbruikbare batterijen. Gedefinieerd door kenmerkende vormfactoren die onmiskenbaar van u zijn.",
    "view-link": "Bekijken",

    "products-available-from-our-global-facilities":
      "Alle overige producten beschikbaar via onze wereldwijde faciliteiten",

    "trusted-by-top-brands": "VERTROUWD DOOR TOPMERKEN",

    "customizations.headline": "Onderscheid je met maatwerk",
    "customizations.body":
      "Ons gespecialiseerde maatwerkteam werkt met u samen om een onderscheidende uitstraling voor uw merk te realiseren.",
    "customizations.button": "Start uw merkmaatwerk",
  },

  // 🇫🇷 FRENCH
  [Localizations.French]: {
    "hero.title":
      "Approuvé par les principales marques européennes de vape au cannabis médical et récréatif",
    "hero.subtitle": "Stocké à Prague et prêt à être expédié",
    "hero.get-samples-btn": "Contactez-nous pour les commandes",

    "certifications.headline":
      "Certifié conforme aux normes de sécurité européennes",
    "certifications.body":
      "Tous les produits sont fabriqués dans des sites de production certifiés à l’international avec des contrôles qualité rigoureux. Les batteries et dispositifs tout-en-un sont certifiés CE et marqués WEEE.",
    "process-certifications": "Certifications des processus",
    "battery-safety": "Sécurité des batteries",

    "mdr.eyebrow": "Programme MDR ACTIVE",
    "mdr.headline": "Lancez votre propre dispositif certifié MDR en Europe",
    "mdr.body":
      "Partagez vos coordonnées et notre équipe MDR européenne vous contactera.",
    "mdr.name": "Nom",
    "mdr.email": "E-mail professionnel",
    "mdr.phone": "Numéro de téléphone",
    "mdr.button": "Démarrer votre échange MDR",
    "mdr.captcha-error": "Veuillez confirmer que vous n'êtes pas un robot.",
    "mdr.disclaimer":
      "En soumettant ce formulaire, vous acceptez qu'ACTIVE utilise vos informations pour répondre à votre demande. Consultez notre <a href=\"/policy/privacy-policy\">Politique de confidentialité</a> pour en savoir plus.",

    "explore-out-lineup-stocked-in-the-eu": "Produits en stock dans l’UE",

    "category.cartridges.title": "Cartouches",
    "category.cartridges.body":
      "Vous trouverez <a href=\"/no-burn-vapor-technology\">la No-Burn Technology® d’ACTIVE</a> dans chaque cartouche ACTIVE. Grâce à notre cœur en céramique exclusif, nous avons perfectionné la façon dont l’huile est absorbée, chauffée et vaporisée.",
    "category.all-in-ones.title": "Tout-en-un",
    "category.all-in-ones.body":
      "Les consommateurs associent souvent batteries et cartouches de marques différentes. Mais pour garantir à vos clients une expérience optimale, pensez aux tout-en-un ACTIVE. Une cartouche et une batterie parfaitement synchronisées pour restituer les nuances de vos saveurs exactement comme vous les avez imaginées.",
    "category.batteries.title": "Batteries",
    "category.batteries.body":
      "La surchauffe dégrade votre huile. Les batteries ACTIVE sont donc conçues pour réguler la température grâce à la technologie ACTIVE Pulse. Vos formulations riches en cannabinoïdes et vos saveurs fidèles à la variété sont préservées, sans renoncer à une bouffée généreuse.",

    "active-axil-mini-air-description":
      "Délicieusement différent. Compact à l’extérieur, puissant à l’intérieur. Conçu pour les distillats et les nouveaux cannabinoïdes, compatible avec le live resin liquide.",
    "active-axil-mini-pro-description":
      "Rare pour sa taille, le Mini Pro intègre une ingénierie haut de gamme avec céramique en zircone pour une restitution exceptionnelle des saveurs.",
    "active-axil-description":
      "Un prix adapté au marché de masse sans compromis sur la fiabilité et la constance. Conçu pour les distillats et les nouveaux cannabinoïdes.",
    "active-leaf-description":
      "Délicieusement différent. Compact à l’extérieur, puissant à l’intérieur. Conçu pour les distillats et les nouveaux cannabinoïdes, compatible avec le live resin liquide.",
    "active-ceramic-description":
      "Conçu pour les extraits premium. Esthétique soignée et restitution optimale des saveurs grâce à un corps en verre et un axe central en céramique de zircone.",
    "ezclick-ceramic-pro-description":
      "Conçu pour les extraits premium, le Ceramic Pro dispose d’un corps en verre et d’un axe central en zircone pour une restitution des saveurs exceptionnelle.",
    "ezclick-glass-description":
      "Un équilibre entre saveur, prix accessible et fiabilité pour vos distillats et nouveaux cannabinoïdes, dans un corps en verre.",
    "active-root-xl-description":
      "Un corps plus large, conçu pour s’adapter parfaitement aux cartouches ACTIVE XL et en sublimer l’expérience.",
    "active-sprout-description":
      "Conçue pour la polyvalence, avec tension et puissance réglables et la technologie ACTIVE Pulse, pour tous les extraits.",
    "available-mouthpieces": "Embouts disponibles :",
    "singular.headline": "Plateforme Universelle de Vape Singular®",
    "singular.body":
      "Singular est une plateforme modulaire unique en son genre. Conçue pour tous les types d’extraits avec des batteries réutilisables, et définie par des formes emblématiques qui vous appartiennent.",
    "view-link": "Voir",

    "products-available-from-our-global-facilities":
      "Tous les autres produits sont disponibles depuis nos sites de production mondiaux",

    "trusted-by-top-brands": "APPROUVÉ PAR LES PLUS GRANDES MARQUES",

    "customizations.headline": "Démarquez-vous grâce à la personnalisation",
    "customizations.body":
      "Notre équipe spécialisée en personnalisation collaborera avec vous afin de créer une identité visuelle distinctive pour votre marque.",
    "customizations.button": "Démarrer la personnalisation de marque",
  },

  // 🇩🇪 GERMAN
  [Localizations.German]: {
    "hero.title":
      "Vertrauen führender europäischer Marken für medizinische und Freizeit-Cannabis-Vapes",
    "hero.subtitle": "In Prag gelagert und versandbereit",
    "hero.get-samples-btn": "Kontaktieren Sie uns für Bestellungen",

    "certifications.headline":
      "Zertifiziert für europäische Sicherheitsstandards",
    "certifications.body":
      "Alle Produkte werden in international zertifizierten Produktionsstätten mit strengen Qualitätskontrollen hergestellt. Batterien und All-in-One-Geräte sind CE-zertifiziert und WEEE-gekennzeichnet.",
    "process-certifications": "Prozesszertifizierungen",
    "battery-safety": "Batteriesicherheit",

    "mdr.eyebrow": "ACTIVE MDR-Programm",
    "mdr.headline":
      "Bringen Sie Ihr eigenes MDR-zertifiziertes Gerät in Europa auf den Markt",
    "mdr.body":
      "Teilen Sie uns Ihre Daten mit und unser europäisches MDR-Team meldet sich bei Ihnen.",
    "mdr.name": "Name",
    "mdr.email": "Geschäftliche E-Mail",
    "mdr.phone": "Telefonnummer",
    "mdr.button": "MDR-Gespräch starten",
    "mdr.captcha-error": "Bitte bestätigen Sie, dass Sie kein Roboter sind.",
    "mdr.disclaimer":
      "Mit dem Absenden dieses Formulars erklären Sie sich damit einverstanden, dass ACTIVE Ihre Daten zur Beantwortung Ihrer Anfrage verwendet. Weitere Informationen finden Sie in unserer <a href=\"/policy/privacy-policy\">Datenschutzerklärung</a>.",

    "explore-out-lineup-stocked-in-the-eu":
      "Produkte mit Lagerbestand in der EU",

    "category.cartridges.title": "Kartuschen",
    "category.cartridges.body":
      "In jeder ACTIVE-Kartusche steckt <a href=\"/no-burn-vapor-technology\">ACTIVEs No-Burn Technology®</a>. Dank unseres eigenen Keramikkerns haben wir perfektioniert, wie Öl aufgenommen, erhitzt und verdampft wird.",
    "category.all-in-ones.title": "All-in-One-Geräte",
    "category.all-in-ones.body":
      "Verbraucher kombinieren Batterien und Kartuschen oft nach Belieben. Damit Ihre Kunden ein optimales Erlebnis haben, sollten Sie die All-in-One-Geräte von ACTIVE in Betracht ziehen. Kartusche und Batterie sind perfekt aufeinander abgestimmt und geben die Nuancen Ihrer Aromen genau so wieder, wie Sie es beabsichtigt haben.",
    "category.batteries.title": "Batterien",
    "category.batteries.body":
      "Überhitzung beeinträchtigt Ihr Öl. Deshalb regulieren ACTIVE-Batterien die Temperatur mit der ACTIVE Pulse Technologie. Ihre cannabinoidreichen Formulierungen und sortentypischen Aromen bleiben erhalten – ohne auf den großen Zug zu verzichten.",

    "active-axil-mini-air-description":
      "Angenehm anders. Außen klein, innen groß. Entwickelt für Destillate und neuartige Cannabinoide, kompatibel mit flüssigem Live Resin.",
    "active-axil-mini-pro-description":
      "Selten in dieser Größe: Der Mini Pro bietet High-End-Technik mit Zirkonia-Keramik für außergewöhnlichen Geschmack.",
    "active-axil-description":
      "Preislich für den Massenmarkt konzipiert – ohne Kompromisse bei Zuverlässigkeit und Konsistenz. Entwickelt für Destillate und neuartige Cannabinoide.",
    "active-leaf-description":
      "Angenehm anders. Außen klein, innen groß. Entwickelt für Destillate und neuartige Cannabinoide, kompatibel mit flüssigem Live Resin.",
    "active-ceramic-description":
      "Entwickelt für Premium-Extrakte. Hochwertiges Design und exzellente Geschmacksentfaltung mit Glaskörper und Zirkonia-Keramik-Centerpost.",
    "ezclick-ceramic-pro-description":
      "Für Premium-Extrakte entwickelt. Der Ceramic Pro verfügt über einen Glaskörper und einen Zirkonia-Centerpost für außergewöhnlichen Geschmack.",
    "ezclick-glass-description":
      "Eine Balance aus Geschmack, Preis und Zuverlässigkeit für Ihre Destillate und neuartigen Cannabinoide – im Glaskörper.",
    "active-root-xl-description":
      "Ein breiterer Korpus, der perfekt zu ACTIVE XL Kartuschen passt und das Erlebnis noch besser macht.",
    "active-sprout-description":
      "Für Vielseitigkeit entwickelt: einstellbare Spannung, Wattzahl und ACTIVE Pulse für jedes Extrakt.",
    "available-mouthpieces": "Verfügbare Mundstücke:",
    "singular.headline": "Singular® Universelles Vape-Plattform",
    "singular.body":
      "Singular ist eine weltweit einzigartige modulare Plattform. Entwickelt für jedes Extrakt mit wiederverwendbaren Batterien. Definiert durch charakteristische Formfaktoren, die unverkennbar Ihre Marke sind.",
    "view-link": "Ansehen",

    "products-available-from-our-global-facilities":
      "Alle weiteren Produkte sind über unsere globalen Standorte erhältlich",

    "trusted-by-top-brands": "VERTRAUT VON TOP-MARKEN",

    "customizations.headline": "Heben Sie sich mit Individualisierung ab",
    "customizations.body":
      "Unser spezialisiertes Individualisierungsteam arbeitet mit Ihnen zusammen, um einen unverwechselbaren Look für Ihre Marke zu schaffen.",
    "customizations.button": "Markenindividualisierung starten",
  },

  // 🇪🇸 SPANISH
  [Localizations.Spanish]: {
    "hero.title":
      "Con la confianza de las principales marcas europeas de vapeo de cannabis médico y recreativo",
    "hero.subtitle": "Almacenado en Praga y listo para envío",
    "hero.get-samples-btn": "Contáctanos para pedidos",

    "certifications.headline":
      "Certificado para el cumplimiento de seguridad europeo",
    "certifications.body":
      "Todos los productos se fabrican en plantas certificadas internacionalmente con estrictos controles de calidad. Las baterías y los dispositivos todo-en-uno cuentan con certificación CE y marcado WEEE.",
    "process-certifications": "Certificaciones de proceso",
    "battery-safety": "Seguridad de baterías",

    "mdr.eyebrow": "Programa MDR de ACTIVE",
    "mdr.headline":
      "Lance su propio dispositivo con certificación MDR en Europa",
    "mdr.body":
      "Comparta sus datos y nuestro equipo europeo de MDR se pondrá en contacto con usted.",
    "mdr.name": "Nombre",
    "mdr.email": "Correo electrónico profesional",
    "mdr.phone": "Número de teléfono",
    "mdr.button": "Inicie su conversación sobre MDR",
    "mdr.captcha-error": "Confirme que no es un robot.",
    "mdr.disclaimer":
      "Al enviar este formulario, acepta que ACTIVE utilice su información para responder a su consulta. Consulte nuestra <a href=\"/policy/privacy-policy\">Política de privacidad</a> para obtener más información.",

    "explore-out-lineup-stocked-in-the-eu":
      "Productos en stock dentro de la UE",

    "category.cartridges.title": "Cartuchos",
    "category.cartridges.body":
      "Encontrará <a href=\"/no-burn-vapor-technology\">la No-Burn Technology® de ACTIVE</a> en todos los cartuchos ACTIVE. Gracias a nuestro núcleo cerámico exclusivo, hemos perfeccionado la forma en que el aceite se absorbe, se calienta y se vaporiza.",
    "category.all-in-ones.title": "Dispositivos todo en uno",
    "category.all-in-ones.body":
      "Los consumidores suelen combinar baterías y cartuchos de distintas marcas. Pero, para garantizar a sus clientes una experiencia óptima, considere los dispositivos todo en uno de ACTIVE. Un cartucho y una batería perfectamente sincronizados para transmitir los matices de sus sabores tal y como los concibió.",
    "category.batteries.title": "Baterías",
    "category.batteries.body":
      "El sobrecalentamiento degrada su aceite. Por eso las baterías ACTIVE están diseñadas para regular la temperatura con la tecnología ACTIVE Pulse. Sus formulaciones ricas en cannabinoides y sus sabores fieles a la variedad se conservan sin renunciar a una calada potente.",

    "active-axil-mini-air-description":
      "Deliciosamente diferente. Pequeño por fuera, grande por dentro. Diseñado para destilados y cannabinoides novedosos, compatible con live resin líquido.",
    "active-axil-mini-pro-description":
      "Raro en su tamaño: el Mini Pro incorpora ingeniería de alta gama con cerámica de circonio para un sabor excepcional.",
    "active-axil-description":
      "Precio competitivo para el mercado masivo sin sacrificar fiabilidad ni consistencia. Diseñado para destilados y cannabinoides novedosos.",
    "active-leaf-description":
      "Deliciosamente diferente. Pequeño por fuera, grande por dentro. Diseñado para destilados y cannabinoides novedosos, compatible con live resin líquido.",
    "active-ceramic-description":
      "Diseñado para extractos premium. Estética elegante y excelente entrega de sabor con cuerpo de vidrio y poste central de cerámica de circonio.",
    "ezclick-ceramic-pro-description":
      "Diseñado para extractos premium. El Ceramic Pro cuenta con cuerpo de vidrio y poste central de circonio para una entrega de sabor excepcional.",
    "ezclick-glass-description":
      "Un equilibrio entre sabor, precio y fiabilidad para sus destilados y cannabinoides novedosos, en un cuerpo de vidrio.",
    "active-root-xl-description":
      "Un cuerpo más ancho, diseñado para encajar a la perfección con los cartuchos ACTIVE XL y realzar la experiencia.",
    "active-sprout-description":
      "Diseñada para la versatilidad, con voltaje y vataje ajustables y ACTIVE Pulse para cualquier extracto.",
    "available-mouthpieces": "Boquillas disponibles:",
    "singular.headline": "Plataforma Universal de Vapeo Singular®",
    "singular.body":
      "Singular es una plataforma modular única en su clase. Diseñada para cualquier extracto con baterías reutilizables y definida por formas distintivas que son inconfundiblemente suyas.",
    "view-link": "Ver",

    "products-available-from-our-global-facilities":
      "Todos los demás productos disponibles desde nuestras instalaciones globales",

    "trusted-by-top-brands": "EN QUIEN CONFÍAN LAS MEJORES MARCAS",

    "customizations.headline": "Destaque con personalización",
    "customizations.body":
      "Nuestro equipo especializado en personalización colaborará con usted para crear una imagen distintiva para su marca.",
    "customizations.button": "Iniciar personalización de marca",
  },
};
